import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";

@Injectable()
export class ApiTrackingInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Obtenir le composant/page actuel
    const currentRoute = this.router.url;

    // Ajouter les en-têtes de traçage à chaque requête
    const trackedRequest = request.clone({
      setHeaders: {
        "X-Request-Source": currentRoute,
        "X-Request-Timestamp": new Date().toISOString(),
      },
    });

    return next.handle(trackedRequest);
  }
}
